import { buildProps } from '@element-plus/utils'
import { componentSizes } from '@element-plus/constants'
import type { ExtractPropTypes } from 'vue'
import type Simple from './simple.vue'

export const paginationSimpleProps = buildProps({
  size: {
    type: String,
    values: componentSizes,
  },
} as const)

export type PaginationSimpleProps = ExtractPropTypes<
  typeof paginationSimpleProps
>

export type PaginationSimpleInstance = InstanceType<typeof Simple>
